import { Checkbox, Table, Tbody, Td, Th, Thead, Tooltip, Tr } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { db } from "~/db/db";

import { useLocation } from "react-router-dom";
import CurrencyInputAlternateNoFormik from "~components/Form/components/CurrencyInputAlternateNoFormik";
import { money } from "~hooks/useHelpers";
import CalendarIcon2, { AddButton, EditFormIcon, TrashCan, ClearMM } from "~misc/icons";
import { valorMostrar } from "~services/GlobalServices";
import warningimg from "../../../../assets/images/warningImg.png";
import ModalResponse from "~components/Modal/ModalResponse";
import useModalAction from "~components/Modal/hooks/useModalAction";
import { useTableState } from "~pages/PricesTableV2/context/TableStateContext";

const PricesTable = ({
  data,
  selectedItems,
  handleCheckboxChange,
  hideNegociacao,
  handleChangeCheckbox,
  hidePrazo,
  showMicrorregiao,
  handleAddButton,
  handleDeleteButton,
  hideCentro,
  id,
  aplicaServicos,
  showCheckboxes = true,
  negotiationsDisabled = false,
}) => {
  const [modifiedRows, setModifiedRows] = useState(new Set());
  const [valores, setValores] = useState({});
  const [initialValues, setInitialValues] = useState({});
  const { alteracoes, addAlteracao, removeAlteracao, toggleCheckboxAlteracao } = useTableState();
  const pathname = window.location.pathname;
  const isPaginaRaiz = pathname === "/tabela-preco";
  const [disabledAction] = useState({
    input: null,
    checkbox: null,
  });

  const location = useLocation();
  const isTabelaPreco = /^\/tabela-preco\/\d+$/.test(location.pathname);

  const [produtosEditados, setProdutosEditados] = useState({});
  function reCalc(index, newValue, data) {
    const produtosFiltrados = data.produtos.filter((produto) => produto.id === index);
    const produto = produtosFiltrados[0];
    const faixa = parseFloat(newValue);
    let precoFinalFOB = parseFloat(produto.precoFinalFOB);
    let precoFinalCIF = parseFloat(produto.precoFinalCIF);

    if (produto.valorPrecoCIF === undefined && produto.valorPrecoFOB === undefined) {
      const precoRegraFOB = parseFloat(produto.precoRegraFOB);
      const precoRegraCIF = parseFloat(produto.precoRegraCIF);
      if (produto.tipoCondicaoLabel != "Condição Especial") {
        precoFinalFOB = precoRegraFOB * (1 + faixa / 100);
        precoFinalCIF = precoRegraCIF * (1 + faixa / 100);
      }

      setProdutosEditados((prev) => ({
        ...prev,
        [index]: {
          precoFinalFob: precoFinalFOB.toFixed(2),
          precoFinalCif: precoFinalCIF.toFixed(2),
        },
      }));
    } else {
      if (produto.tipoCondicaoLabel != "Condição Especial") {
        precoFinalFOB = (1 + faixa / 100) * produto.valorPrecoFOB;
        precoFinalCIF = (1 + faixa / 100) * produto.valorPrecoCIF;
      }

      setProdutosEditados((prev) => ({
        ...prev,
        [index]: {
          precoFinalFob: precoFinalFOB.toFixed(2),
          precoFinalCif: precoFinalCIF.toFixed(2),
        },
      }));
    }
  }

  const handleInputChange = (index, newValue, row, temPrecoAprovado = false) => {
    const infoAlteracao = {
      clienteId: id || row?.clienteId,
      precoRegraId: !temPrecoAprovado ? row?.id : null,
      precoClienteId: temPrecoAprovado ? row?.id : null,
      faixa: newValue,
    };

    setValores((prevState) => ({
      ...prevState,
      [index]: newValue,
    }));

    const produto = (data?.produtos || []).find((pr) => pr.id == index);
    let currentInitialValue = initialValues[index];

    if (!currentInitialValue && produto) {
      currentInitialValue = produto.faixa;
      setInitialValues((prev) => ({
        ...prev,
        [index]: produto.faixa,
      }));
    }

    const initialValue = currentInitialValue ?? produto?.faixa ?? 0;
    const numberInitialValue = parseFloat(initialValue);
    const numberNewValue = parseFloat(newValue);

    setModifiedRows((prev) => {
      const newModifiedRows = new Set(prev);

      if (numberNewValue !== numberInitialValue) {
        reCalc(index, newValue, data);
        newModifiedRows.add(index);

        addAlteracao({ id: produto.id, faixa: newValue, valorInicial: initialValue, ...infoAlteracao });
      } else {
        newModifiedRows.delete(index);
        reCalc(index, newValue, data);

        removeAlteracao(produto.id);
      }

      return newModifiedRows;
    });
  };

  const getPrecosServicos = (row) => {
    if (!aplicaServicos) return 0;
    return (
      (aplicaServicos.fracionamento ? row.precosServicos.precoFracionamento : 0) +
      (aplicaServicos.descarga ? row.precosServicos.precoDescarga : 0)
    );
  };

  const [prazoPagamentos, setPrazoPagamentos] = useState([]);
  useEffect(() => {
    db.prazoPagamento.filter((p) => p.ativo).toArray().then(setPrazoPagamentos);
  }, []);

  const { isModalOpenAction, closeModalAction } = useModalAction();

  const handleRevert = (row) => {
    setModifiedRows((prevRows) => {
      const newRows = new Set(prevRows);
      newRows.delete(row.id);
      return newRows;
    });
    setValores((prevState) => ({
      ...prevState,
      [row.id]: row.faixa ?? 0,
    }));

    removeAlteracao(row.id);
  };

  const renderCheckboxCell = (
    row,
    {
      showCheckboxes,
      data,
      modifiedRows,
      alteracoes,
      handleChangeCheckbox,
      handleCheckboxChange,
      toggleCheckboxAlteracao,
      disabledAction,
      selectedItems,
    }
  ) => {
    if (!(showCheckboxes && data.checkboxes && !row.codigoIdentificacao)) return null;
    return (
      <Td
        className={
          modifiedRows.has(row.id) && alteracoes.some((item) => item.id === row.id)
            ? "!bg-[#034ea2] !text-white checkbox-column"
            : " no-border checkbox-column"
        }
      >
        <Checkbox
          onChangeCapture={handleChangeCheckbox}
          onChange={() => {
            handleCheckboxChange(row.id);
            toggleCheckboxAlteracao(row);
          }}
          className={`checkbox ${disabledAction.input ? "opacity-25" : ""}`}
          isChecked={selectedItems[row.id] || false}
          disabled={disabledAction.input}
        />
      </Td>
    );
  };

  const renderProductDescriptionCell = (row, { modifiedRows, alteracoes, warningimg }) => (
    <Td
      className={
        modifiedRows.has(row.id) && alteracoes.some((item) => item.id === row.id)
          ? "!bg-[#034ea2] !text-white"
          : " no-border"
      }
    >
      <p className="flex items-center gap-x-2 text-table">
        {row?.emAprovacao && (
          <Tooltip label="Há uma negociação em andamento para esse produto">
            <img src={warningimg} className="w-6" alt="" />
          </Tooltip>
        )}
        {row.codigoProduto} - {row.descricaoProduto ?? row.produtoLabel}
      </p>
    </Td>
  );

  const renderFilialCell = (row, { modifiedRows, alteracoes }) => (
    <Td
      className={
        modifiedRows.has(row.id) && alteracoes.some((item) => item.id === row.id) ? "!bg-[#034ea2] !text-white " : " "
      }
      style={{ color: row.tipoCondicaoLabel?.toLowerCase() == "condição especial" ? "red" : "" }}
    >
      {row.nomeFilial}
    </Td>
  );

  const renderNegociacaoCell = (row, { modifiedRows, alteracoes, handleInputChange, valores, disabledAction }) => (
    <Td
      className={
        modifiedRows.has(row.id) && alteracoes.some((item) => item.id === row.id) ? "!bg-[#034ea2] !text-white " : " "
      }
    >
      {row.faixa || row.codigoIdentificacao ? (
        <>
          {row.tipoCondicaoLabel?.toLowerCase() == "condição especial" && row.faixa === "0.00" ? (
            <span className="money" style={{ color: "red" }}>
              C.E
            </span>
          ) : (
            <label className="input-container">
              <CurrencyInputAlternateNoFormik
                input={Number(row.faixa ?? 0).toFixed(2)}
                prefix=""
                suffix={
                  row.faixa != "0.00" || row.tipoCondicaoLabel?.toLowerCase() === "faixa" || row.codigoIdentificacao
                    ? "%"
                    : ""
                }
                index={row.id}
                handleInputChange={(idx, newValue) => handleInputChange(idx, newValue, row, !row.codigoIdentificacao)}
                forceUpdateValue={valores[row.id]}
                disabledInput={negotiationsDisabled}
              />
            </label>
          )}
        </>
      ) : (
        <span className={`text-[${row.color?.semDesconto ?? "#FFF"}]`}>{row.tipoCondicaoLabel} sem desconto</span>
      )}
    </Td>
  );

  const renderFobCell = (row, { modifiedRows, alteracoes, isPaginaRaiz, produtosEditados, money, valorMostrar }) => {
    const precoFinalEditado = produtosEditados[row.id]?.precoFinalFob;
    const precoFinal = row.precoFinalFOB || row.precoFinalFob || row.valorPrecoFOB;
    const precoBase = row.precoFinalFOB || row.valorPrecoFOB || row.precoRegraFOB;
    const precoEspecial = row.precoEspecialFOB || 0;
    const hasPrecoRegraFOB = isPaginaRaiz ? row.precoRegraFOB !== undefined : row.precoRegraFOB === undefined;

    if (hasPrecoRegraFOB && precoFinalEditado) {
      const fobValue = ` ${money(precoFinalEditado)}`;
      return renderFobTd(fobValue, row, modifiedRows, alteracoes);
    }
    if (hasPrecoRegraFOB) {
      const fobValue = ` ${money(precoFinal)}`;
      return renderFobTd(fobValue, row, modifiedRows, alteracoes);
    }
    if (precoFinalEditado) {
      const fobValue = ` ${valorMostrar(precoBase, precoFinalEditado, precoEspecial)}`;
      return renderFobTd(fobValue, row, modifiedRows, alteracoes);
    }
    const fobValue = ` ${valorMostrar(precoBase, row.precoFinalFOB, precoEspecial)}`;
    return renderFobTd(fobValue, row, modifiedRows, alteracoes);
  };

  function renderFobTd(fobValue, row, modifiedRows, alteracoes) {
    return (
      <Td
        className={
          modifiedRows.has(row.id) && alteracoes.some((item) => item.id === row.id) ? "!bg-[#034ea2] !text-white " : " "
        }
      >
        <span style={row.color?.fob ? { color: "red" } : {}}>{fobValue}</span>
      </Td>
    );
  }

  const renderCifCell = (
    row,
    { modifiedRows, alteracoes, isPaginaRaiz, produtosEditados, money, valorMostrar, getPrecosServicos }
  ) => {
    const precoFinalEditado = produtosEditados[row.id]?.precoFinalCif;
    const precoFinal = row.precoFinalCif ?? row.valorPrecoCIF ?? row.precoFinalCIF;
    const precoBase = row.valorPrecoFOB ?? row.precoRegraCIF ?? row.precoFinalCIF;
    const precoEspecial = row.precoEspecialCIF || 0;
    const servicos = getPrecosServicos(row);
    const hasPrecoRegraCIF = isPaginaRaiz ? row.precoRegraCIF !== undefined : row.precoRegraCIF === undefined;

    if (hasPrecoRegraCIF && precoFinalEditado) {
      const cifValue = ` ${money(Number(precoFinalEditado) + servicos)}`;
      return renderCifTd(cifValue, row, modifiedRows, alteracoes);
    }
    if (hasPrecoRegraCIF) {
      const cifValue = ` ${money(Number(precoFinal) + servicos)}`;
      return renderCifTd(cifValue, row, modifiedRows, alteracoes);
    }
    if (precoFinalEditado) {
      const cifValue = ` ${valorMostrar(precoBase, precoFinalEditado, precoEspecial, servicos)}`;
      return renderCifTd(cifValue, row, modifiedRows, alteracoes);
    }
    const cifValue = ` ${valorMostrar(precoBase, row.precoFinalCIF, precoEspecial, servicos)}`;
    return renderCifTd(cifValue, row, modifiedRows, alteracoes);
  };

  function renderCifTd(cifValue, row, modifiedRows, alteracoes) {
    return (
      <Td
        className={
          modifiedRows.has(row.id) && alteracoes.some((item) => item.id === row.id)
            ? "!bg-[#034ea2] !text-white  no-border"
            : " no-border"
        }
      >
        <span style={row.color?.cif ? { color: "red" } : {}}>{cifValue}</span>
      </Td>
    );
  }

  const getPrazoLabel = (row) => {
    const labels = [];

    const findLabel = (id) => {
      if (id == null) return null;
      if (typeof id === "number") {
        const prazo = prazoPagamentos.find((p) => p.id === id);
        return prazo ? `${prazo.codigo} - ${prazo.nome}` : `${id}`;
      }
      return id;
    };

    const cifDisplay = findLabel(row?.prazoCIF) ?? findLabel(row?.prazoPagamentoCIFId);
    const fobDisplay = findLabel(row?.prazoFOB) ?? findLabel(row?.prazoPagamentoFOBId);

    if (cifDisplay) labels.push(`CIF: ${cifDisplay}`);
    if (fobDisplay) labels.push(`FOB: ${fobDisplay}`);
    return labels.join(" / ");
  };

  const renderPrazoCell = (row, { hidePrazo, isTabelaPreco, modifiedRows, alteracoes }) => {
    if (!hidePrazo && (row.prazoCIF || row.prazoFOB || row.prazoPagamentoCIFId || row.prazoPagamentoFOBId)) {
      return (
        <Td
          className={
            modifiedRows.has(row.id) && alteracoes.some((item) => item.id === row.id)
              ? "!bg-[#034ea2] !text-white no-border sm"
              : " no-border sm"
          }
        >
          <div className="calendar-icon w-full flex justify-end">
            <Tooltip label={getPrazoLabel(row)}>
              <CalendarIcon2 />
            </Tooltip>
          </div>
        </Td>
      );
    }
    return isTabelaPreco ? (
      <Td
        className={
          modifiedRows.has(row.id) && alteracoes.some((item) => item.id === row.id) ? "!bg-[#034ea2] !text-white" : ""
        }
      >
        {" "}
      </Td>
    ) : (
      <Td
        className={
          modifiedRows.has(row.id) && alteracoes.some((item) => item.id === row.id) ? "!bg-[#034ea2] !text-white" : ""
        }
      />
    );
  };

  const renderActionButtonsCell = (
    row,
    { modifiedRows, alteracoes, handleAddButton, handleDeleteButton, handleRevert, id }
  ) => (
    <Td
      className={
        modifiedRows.has(row.id) && alteracoes.some((item) => item.id === row.id)
          ? "!bg-[#034ea2] !text-white action-buttons-column"
          : " action-buttons-column"
      }
    >
      <div className="action-buttons-row">
        {!row.codigoIdentificacao ? (
          <>
            <button
              type="button"
              onClick={() =>
                handleAddButton(
                  row.grupoProdutoId ?? row.grupoMaterialId,
                  row.produtoId,
                  row.filialId,
                  id ?? row.clienteId,
                  "editar"
                )
              }
              className="action-button"
            >
              <EditFormIcon className="icon" fill="#FFF" size={18} />
            </button>
            <button type="button" onClick={() => handleDeleteButton(row.id, row)} className="action-button">
              <TrashCan className="icon" fill="#FFF" size={18} />
            </button>
          </>
        ) : (
          <button
            type="button"
            onClick={() =>
              handleAddButton(
                row.grupoProdutoId ?? row.grupoMaterialId,
                row.produtoId,
                row.filialId,
                id ?? row.clienteId,
                "nova"
              )
            }
            className="action-button"
          >
            <AddButton className="icon" fill="#FFF" size={18} />
          </button>
        )}
        {modifiedRows.has(row.id) && alteracoes.some((item) => item.id === row.id) && (
          <button type="button" onClick={() => handleRevert(row)} className="action-button cursor-pointer">
            <ClearMM />
          </button>
        )}
      </div>
    </Td>
  );

  return (
    data?.produtos?.length > 0 && (
      <div className="table-container">
        <ModalResponse
          isOpen={isModalOpenAction}
          closeModal={closeModalAction}
          status={"alert"}
          message={
            <p className="max-w-[500px]">
              A partir de 30 solicitações, é possível que o desempenho seja afetado. É recomendável enviar as alterações
              atuais, caso já estejam corretas.
            </p>
          }
          submessage={""}
          button="Ok"
        />
        <Table className="table">
          <colgroup>
            {showCheckboxes && data.checkboxes && <col style={{ width: 10 }} />}
            <col style={{ width: 500 }} />
            <col style={{ width: 150 }} />
            <col style={{ width: 100 }} />
            <col style={{ width: 100 }} />
            <col style={{ width: 100 }} />
            {!hidePrazo && <col style={{ width: 10 }} />}
            <col style={{ width: 10 }} />
          </colgroup>

          <Thead>
            <Tr>
              <Th colSpan={showCheckboxes && data.checkboxes ? 2 : 1}>
                <div className="flex items-center gap-x-2">
                  {data.header?.icon}
                  {data.header?.title}
                  {data.header?.alert ? (
                    <Tooltip label="Desconto com vigência próxima do vencimento">
                      <img src={warningimg} className="w-6" alt="" />
                    </Tooltip>
                  ) : null}
                </div>
              </Th>

              {!hideCentro && <Th>Centro</Th>}

              {!hideNegociacao && <Th>Negociação</Th>}

              {showMicrorregiao && <Th>Microrregião</Th>}

              <Th>
                FOB <small>(R$/un)</small>
              </Th>

              <Th>
                CIF <small>(R$/un)</small>
              </Th>
              {!hidePrazo && (data?.produtos?.prazoCIF || data?.produtos?.prazoFob) ? (
                <Th />
              ) : (
                <>{isTabelaPreco ? <Th></Th> : <Th />}</>
              )}

              <Th />
            </Tr>
          </Thead>

          <Tbody>
            {data?.produtos?.map((row, index) => (
              <Tr key={`${row.id}-${index}`}>
                {renderCheckboxCell(row, {
                  showCheckboxes,
                  data,
                  modifiedRows,
                  alteracoes,
                  handleChangeCheckbox,
                  handleCheckboxChange,
                  toggleCheckboxAlteracao,
                  disabledAction,
                  selectedItems,
                })}
                {renderProductDescriptionCell(row, { modifiedRows, alteracoes, warningimg })}

                {renderFilialCell(row, { modifiedRows, alteracoes })}

                {showMicrorregiao && <Td>{row.nomeMicrorregiao} </Td>}

                {!hideNegociacao &&
                  renderNegociacaoCell(row, { modifiedRows, alteracoes, handleInputChange, valores, disabledAction })}

                {renderFobCell(row, { modifiedRows, alteracoes, isPaginaRaiz, produtosEditados, money, valorMostrar })}

                {renderCifCell(row, {
                  modifiedRows,
                  alteracoes,
                  isPaginaRaiz,
                  produtosEditados,
                  money,
                  valorMostrar,
                  getPrecosServicos,
                })}

                {renderPrazoCell(row, { hidePrazo, isTabelaPreco, modifiedRows, alteracoes })}

                {renderActionButtonsCell(row, {
                  modifiedRows,
                  alteracoes,
                  handleAddButton,
                  handleDeleteButton,
                  handleRevert,
                  id,
                })}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>
    )
  );
};

PricesTable.propTypes = {
  data: PropTypes.object,
  selectedItems: PropTypes.object,
  handleCheckboxChange: PropTypes.func,
  hideNegociacao: PropTypes.bool,
  handleChangeCheckbox: PropTypes.func,
  hidePrazo: PropTypes.bool,
  showMicrorregiao: PropTypes.bool,
  handleAddButton: PropTypes.func,
  handleDeleteButton: PropTypes.func,
  hideCentro: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  aplicaServicos: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  showCheckboxes: PropTypes.bool,
  negotiationsDisabled: PropTypes.bool,
};

export default PricesTable;
